import { Button, Form, Input, Select, message, Space, Popconfirm } from "antd";
import { serverFetch } from "../../server";
import { userOptionsWithPosition } from "../../extensions/dicts";
import { useState, useEffect } from "react";
import { isMobile } from "../../extensions/design";

const ClientAbonUsageChange = ({ usage, onClose, vid, executorUsers, finish, defaultUserId, clientId, saveLabel }) => {
const [form] = Form.useForm();
const [loading, setLoading] = useState(false);
const [usageItems, setUsageItems] = useState({ qty: 1, userId: defaultUserId, ...usage });
const [localExecutorUsers, setLocalExecutorUsers] = useState(executorUsers);
const [preferredUserId, setPreferredUserId] = useState(usage?.userId ?? defaultUserId ?? null);
const isCreate = !usage?.id;

  useEffect(() => {
    if (preferredUserId != null) return;
    if (!clientId) return;
    serverFetch(`client/${clientId}`)
      .then(data => {
        if (data?.userId != null) {
          setPreferredUserId(data.userId);
        }
      })
      .catch(() => {});
  }, [clientId, preferredUserId]);

  // Эффект для обработки отсутствующего пользователя в списке
  useEffect(() => {
    if (!executorUsers) {
      setLocalExecutorUsers([]);
      return;
    }

    const savedUserId = usage?.userId ?? preferredUserId;
    if (savedUserId != null && !executorUsers.some(u => u.value === savedUserId)) {
      // Если пользователя нет в списке, запрашиваем его отдельно
      serverFetch("User/" + savedUserId)
        .then(u => {
          if (u && u.id != null) {
            setLocalExecutorUsers([
              { ...u, value: u.id, label: u.name, disabled: true }, 
              ...executorUsers
            ]);
          } else {
            const fallbackLabel = usage?.userName;
            // Фолбэк, если API не вернуло пользователя, но в usage есть userName
            setLocalExecutorUsers([
              { value: savedUserId, label: fallbackLabel, disabled: true }, 
              ...executorUsers
            ]);
          }
        })
        .catch(e => {
          message.error(e.userMessage);
          // Фолбэк при ошибке запроса
          const fallbackLabel = usage?.userName;
          setLocalExecutorUsers([
            { value: savedUserId, label: fallbackLabel, disabled: true }, 
            ...executorUsers
          ]);
        });
    } else {
      // Иначе просто используем переданные опции
      setLocalExecutorUsers(executorUsers);
    }
  }, [usage, executorUsers, defaultUserId, preferredUserId]);
  
  const resolveVisitId = () => {
    if (!clientId) {
      message.error("Не удалось определить клиента");
      return null;
    }
    return serverFetch(`visit/Client/${clientId}?isOpen=true`)
      .then(openVisits => {
        if (openVisits && openVisits.length > 0) {
          return openVisits[0].id;
        }
        return serverFetch("visit", {
          method: "POST",
          bodyData: { saleId: usageItems.saleId, clientId },
        }).then(visit => visit.id);
      });
  };

  const onSave = () => {
    setLoading(true);

    if (isCreate) {
      if (!clientId) {
        setLoading(false);
        message.error("Не удалось определить клиента");
        return;
      }
      resolveVisitId()
        .then(visitId => {
          if (visitId == null) return null;
          return serverFetch("sale/Use", {
            method: "POST",
            bodyData: { ...usageItems, visitId },
          });
        })
        .then(res => {
          if (res === null) return;
          onClose(true);
        })
        .catch(e => message.error(e.userMessage))
        .finally(() => setLoading(false));
      return;
    }

    serverFetch("sale/Use", { method: "PUT", bodyData: usageItems })
      .then(() => onClose(true))
      .catch(e => message.error(e.userMessage))
      .finally(() => setLoading(false));
  };

  const onCancel = () => { onClose(usageItems) };

  useEffect(() => {
    const next = { qty: 1, userId: defaultUserId, ...usage };
    form.setFieldsValue(next);
    setUsageItems(next);
  }, [usage, defaultUserId]);

  useEffect(() => {
    if (usage?.id) return;
    if (preferredUserId == null) return;
    if (usageItems.userId === preferredUserId) return;
    const next = { qty: 1, userId: preferredUserId, ...usage };
    form.setFieldsValue(next);
    setUsageItems(next);
  }, [preferredUserId]);

  const onValuesChange = value => setUsageItems({...usageItems, ...value});

  const isSelectedUserDisabled = localExecutorUsers.some(u => u.value === usageItems.userId && u.disabled);

  return !isMobile ?
    <Form form={form} colon={false} labelCol={{ span: 5 }} wrapperCol={{ span: 24 }} loading={loading} onValuesChange={onValuesChange} disabled={!!finish}>
      <Form.Item label="Количество" name="qty" wrapperCol={{ span: 4 }}><Input disabled={!!finish} /></Form.Item>
      <Form.Item label="Исполнитель" name="userId" wrapperCol={{ span: 24 }}><Select options={userOptionsWithPosition(localExecutorUsers)} optionLabelProp="title" disabled={vid === 0 || vid === 4 || !!finish}/></Form.Item>
      <Form.Item label=" " labelCol={{ span: 16 }} style={{marginTop:"16px", marginBottom:"16px"}}>
        <Space>
          {isSelectedUserDisabled ? (
            <Popconfirm title="Подтверждение" description="Сотрудник не является исполнителем услуги, продолжить?" onConfirm={onSave}>
              <Button disabled={!!finish} loading={loading}>{saveLabel ?? (isCreate ? "Списать" : "Сохранить")}</Button>
            </Popconfirm>
          ) : (
            <Button onClick={onSave} disabled={!!finish} loading={loading}>{saveLabel ?? (isCreate ? "Списать" : "Сохранить")}</Button>
          )}
          <Button onClick={onCancel}>Отмена</Button>
        </Space>
      </Form.Item>
    </Form>
    :
    <Form form={form} layout="inline" colon={false} labelCol={{ flex: "100px" }} wrapperCol={{ flex: "1" }} className="client-subitem-content" loading={loading} onValuesChange={onValuesChange}>
      <Form.Item label="Количество" name="qty" style={{width:"100%"}}><Input disabled={!!finish} /></Form.Item>
      <Form.Item label="Исполнитель" name="userId" className="client-abon-form-item-with-margin"><Select style={{width:"100%"}} options={userOptionsWithPosition(localExecutorUsers)} optionLabelProp="title" disabled={vid === 0 || vid === 4 || !!finish}/></Form.Item>
      {isSelectedUserDisabled ? (
        <Popconfirm title="Подтверждение" description="Сотрудник не является исполнителем услуги, продолжить?" onConfirm={onSave}>
          <Button style={{width: "49%", marginRight: "2%", marginTop: 6}} disabled={!!finish} loading={loading}>{saveLabel ?? (isCreate ? "Списать" : "Сохранить")}</Button>
        </Popconfirm>
      ) : (
        <Button style={{width: "49%", marginRight: "2%", marginTop: 6}} onClick={onSave} disabled={!!finish} loading={loading}>{saveLabel ?? (isCreate ? "Списать" : "Сохранить")}</Button>
      )}
      <Button style={{width: "49%", marginTop: 6}} onClick={onCancel}>Отмена</Button>
    </Form>
};
export default ClientAbonUsageChange;
